import type { PlanWallet } from "../api/supPlanApi";

/**
 * Ворота по датам (TECH_PLAN §2.2): поиск открыт, пока не прошла его дата;
 * вопросы — пока не прошла их дата, и только остаток. Дат две: подарок и
 * бонус приложения двигают только дату поиска.
 */

const later = (iso: string | null | undefined, now: number): boolean => {
    if (!iso) return false;
    const t = Date.parse(iso);
    return Number.isFinite(t) && t > now;
};

export const isPlansMode = (w: PlanWallet | null | undefined): w is PlanWallet => w?.mode === "plans";

/** Поиск открыт сейчас (и сервер так сказал, и дата не прошла). */
export const searchOpen = (w: PlanWallet | null | undefined, now: number = Date.now()): boolean =>
    isPlansMode(w) && !!w.search?.open && later(w.search?.until, now);

/** «open» — до даты; «ended» — дата прошла; «none» — поиск ни разу не открывали. */
export const searchState = (w: PlanWallet | null | undefined, now: number = Date.now()): "open" | "ended" | "none" => {
    if (!isPlansMode(w) || !w.search?.until) return "none";
    return searchOpen(w, now) ? "open" : "ended";
};

/** Вопросов специалисту осталось (после их даты — ноль: сгорели). */
export const questionsLeft = (w: PlanWallet | null | undefined, now: number = Date.now()): number => {
    if (!isPlansMode(w) || !w.questions) return 0;
    if (!w.questions.active || !later(w.questions.until, now)) return 0;
    return Math.max(0, Math.floor(w.questions.left || 0));
};

export const canAskSpecialist = (w: PlanWallet | null | undefined, now: number = Date.now()): boolean =>
    questionsLeft(w, now) >= 1;

/** Строка в чате: «до даты», «срок закончился даты» или ничего (вопросов не было). */
export const chatState = (w: PlanWallet | null | undefined, now: number = Date.now()): "active" | "ended" | "none" => {
    if (!isPlansMode(w) || !w.questions?.until) return "none";
    return w.questions.active && later(w.questions.until, now) ? "active" : "ended";
};

/**
 * Баллы «Обучения» за поиск — только пока открыт ОПЛАЧЕННЫЙ срок. Решает сервер
 * (sup_plan.paid_open) и говорит это в виде кошелька (`search.paid`): подарочные 7 дней,
 * месяц за год приложения, выдача админа, клуб и «поделиться» поиск открывают, а баллов
 * не дают. Сайт не угадывает по источнику — подсказку «+50» рисует только по этому полю.
 */
export const searchEarnsPoints = (w: PlanWallet | null | undefined, now: number = Date.now()): boolean =>
    searchOpen(w, now) && w?.search?.paid === true;
